import Vue from 'vue';
import VueRouter from 'vue-router';
import auth, { ready as authReady } from '@/store/auth';
import config from '@/config';
import queryString from 'query-string';

import adminRoutes from '@/router/admin';

Vue.use(VueRouter);

const baseRoutes = [
    {
        path: '/login',
        name: 'Login',
        props: true,
        component: () =>
            import(/* webpackChunkName: "login" */ '../views/Auth/Login.vue'),
    },
    {
        path: '/register',
        name: 'Register',
        props: true,
        component: () =>
            import(/* webpackChunkName: "register" */ '../views/Auth/Register.vue'),
    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        props: true,
        component: () =>
            import(/* webpackChunkName: "register" */ '../views/Auth/ForgotPassword.vue'),
    },
    {
        path: '/set-new-password',
        name: 'SetNewPassword',
        props: true,
        component: () =>
            import(/* webpackChunkName: "register" */ '../views/Auth/SetNewPassword.vue'),
    },
    {
        path: '/register-completed',
        name: 'RegisterCompleted',
        props: true,
        component: () =>
            import(/* webpackChunkName: "register" */ '../views/Auth/RegisterCompleted.vue'),
    },
    {
        path: '/verify/:id',
        name: 'Verify',
        component: () =>
            import(/* webpackChunkName: "register" */ '../views/Auth/Verify.vue'),
        props: (route) => ({
            id: route.params.id,
            hash: route.query.signature,
            expires: route.query.expires,
        }),
    },
    {
        path: '/auth/google/callback',
        name: 'GoogleCallback',
        component: () =>
            import(/* webpackChunkName: "login" */ '../views/Auth/GoogleCallback.vue'),
        props: (route) => ({ query: route.query }),
    },
];

const routes = [ ...baseRoutes, ...adminRoutes, {
    path: '*',
    redirect: '/',
}];

const router = new VueRouter({
    routes,
    scrollBehavior () {
        return { x: 0, y: 0 };
    },
    mode: 'history',
});

const beforeEachRouteGuard = (to, from, next) => {
    const forbiddenRoutesForLoggedInUser = [
        'Login',
        'resetPassword',
        'setNewPassword',
        'Register',
        'RegisterCompleted',
    ];
    const { ott, redirect, ...query } = to.query;

    const nearestPageWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
    document.title = nearestPageWithTitle ? `${nearestPageWithTitle.meta.title} | ${config.value.general.system_name}` : config.value.general.system_name;

    if (ott) {
        next({
            ...to,
            query,
            replace: true,
        });
    } else if (forbiddenRoutesForLoggedInUser.includes(to.name) && auth.value.isLogged) {
        next({ path: '/' });
    } else if (to.name === 'PublicOfferWall' && auth.value.isLogged) {
        next({ name: 'OfferWall' });
    } else if (!to.meta.auth) {
        next();
    } else if (to.meta.auth && !auth.value.isLogged) {
        next({ path: '/login', query: { redirect: window.location.pathname + queryString.stringify(query) } });
    } else {
        next();
    }
};

const beforeEach = (to, from, next) => {
    authReady()
        .then(() => beforeEachRouteGuard(to, from, next));
};

router.beforeEach(beforeEach);

export default router;
